import React from 'react';
import cx from 'classnames';

const TimelineBlockItem = ({ isClientBlock, isFinalBlock, block }) => {
  const { heading, body, finalStepImage } = block;
  return (
    <li
      className={cx('TimelineStep', {
        TimelineClient: isClientBlock,
        TimelineHometap: !isClientBlock,
        TimelineFinal: isFinalBlock,
      })}
    >
      {isFinalBlock && <img src={finalStepImage} alt="" />}
      <article
        className={cx('TimelineStepCopy', {
          isClientCopy: isClientBlock,
          isHompetapCopy: !isClientBlock,
          isFinalCopy: isFinalBlock,
        })}
      >
        {isClientBlock || isFinalBlock ? <h3>{heading}</h3> : <h4>{heading}</h4>}
        <div>{body}</div>
      </article>
    </li>
  );
};

export default TimelineBlockItem;
